export default "__VITE_ASSET__iRoUMh57__"